// Convention:
// - Everything lowercase is an object
// - Everything uppercase is a string (the route)

import { keys } from '../keys';

export const baseUrl = {
  Dashboard: keys().NEXT_PUBLIC_DASHBOARD_URL,
  Marketing: keys().NEXT_PUBLIC_MARKETING_URL,
  PublicApi: keys().NEXT_PUBLIC_PUBLIC_API_URL
} as const;

export const routes = {
  dashboard: {
    Api: `${baseUrl.Dashboard}/api`,
    auth: {
      changeEmail: {
        Expired: `${baseUrl.Dashboard}/auth/change-email/expired`,
        Index: `${baseUrl.Dashboard}/auth/change-email`,
        Invalid: `${baseUrl.Dashboard}/auth/change-email/invalid`,
        Request: `${baseUrl.Dashboard}/auth/change-email/request`
      },
      Error: `${baseUrl.Dashboard}/auth/error`,
      forgetPassword: {
        Index: `${baseUrl.Dashboard}/auth/forgot-password`,
        Success: `${baseUrl.Dashboard}/auth/forgot-password/success`
      },
      Index: `${baseUrl.Dashboard}/auth`,
      RecoveryCode: `${baseUrl.Dashboard}/auth/recovery-code`,
      resetPassword: {
        Expired: `${baseUrl.Dashboard}/auth/reset-password/expired`,
        Index: `${baseUrl.Dashboard}/auth/reset-password`,
        Request: `${baseUrl.Dashboard}/auth/reset-password/request`,
        Success: `${baseUrl.Dashboard}/auth/reset-password/success`
      },
      SignIn: `${baseUrl.Dashboard}/auth/sign-in`,
      ExternalSignIn: `${baseUrl.Dashboard}/auth/external-sign-in`,
      SignUp: `${baseUrl.Dashboard}/auth/sign-up`,
      Totp: `${baseUrl.Dashboard}/auth/totp`,
      verifyEmail: {
        Expired: `${baseUrl.Dashboard}/auth/verify-email/expired`,
        Index: `${baseUrl.Dashboard}/auth/verify-email`,
        Request: `${baseUrl.Dashboard}/auth/verify-email/request`,
        Success: `${baseUrl.Dashboard}/auth/verify-email/success`
      }
    },
    Index: `${baseUrl.Dashboard}/`,
    invitations: {
      AlreadyAccepted: `${baseUrl.Dashboard}/invitations/already-accepted`,
      Index: `${baseUrl.Dashboard}/invitations`,
      Request: `${baseUrl.Dashboard}/invitations/request`,
      Revoked: `${baseUrl.Dashboard}/invitations/revoked`
    },
    Kiosks: `${baseUrl.Dashboard}/kiosks`,
    onboarding: {
      Index: `${baseUrl.Dashboard}/onboarding`,
      Organization: `${baseUrl.Dashboard}/onboarding/organization`,
      User: `${baseUrl.Dashboard}/onboarding/user`
    },
    organizations: {
      Index: `${baseUrl.Dashboard}/organizations`,
      slug: {
        ChoosePlan: `${baseUrl.Dashboard}/organizations/[slug]/choose-plan`,
        Home: `${baseUrl.Dashboard}/organizations/[slug]/home`,
        Index: `${baseUrl.Dashboard}/organizations/[slug]`,
        settings: {
          account: {
            Index: `${baseUrl.Dashboard}/organizations/[slug]/settings/account`,
            Notifications: `${baseUrl.Dashboard}/organizations/[slug]/settings/account/notifications`,
            Profile: `${baseUrl.Dashboard}/organizations/[slug]/settings/account/profile`,
            Security: `${baseUrl.Dashboard}/organizations/[slug]/settings/account/security`
          },
          Index: `${baseUrl.Dashboard}/organizations/[slug]/settings`,
          organization: {
            Billing: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/billing`,
            Developers: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/developers`,
            General: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/general`,
            Index: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization`,
            Members: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/members`,
            Auth: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/auth`,
            Integrations: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/integrations`,
            IntegrationsImportHistory: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/integrations/import-history`,
            AuditLogs: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/audit-logs`,
            Notifications: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/notifications`,
            developers: {
              Index: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/developers`,
              ApiKeys: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/developers/api-keys`,
              Webhooks: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/developers/webhooks`,
              Docs: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/developers/docs`,
              Playground: `${baseUrl.Dashboard}/organizations/[slug]/settings/organization/developers/playground`
            }
          }
        },
        optimize: {
          Personas: `${baseUrl.Dashboard}/organizations/[slug]/optimize/personas`,
          Tuning: `${baseUrl.Dashboard}/organizations/[slug]/optimize/tuning`,
          Campaigns: `${baseUrl.Dashboard}/organizations/[slug]/optimize/campaigns`,
          Bundles: `${baseUrl.Dashboard}/organizations/[slug]/optimize/bundles`,
          tagging: {
            Index: `${baseUrl.Dashboard}/organizations/[slug]/optimize/tagging`,
            Candidates: `${baseUrl.Dashboard}/organizations/[slug]/optimize/tagging/candidates`,
            Batches: `${baseUrl.Dashboard}/organizations/[slug]/optimize/tagging/batches`
          }
        },
        operate: {
          kiosks: {
            Index: `${baseUrl.Dashboard}/organizations/[slug]/operate/kiosks`,
            Themes: `${baseUrl.Dashboard}/organizations/[slug]/operate/kiosks/themes`
          },
          Conversations: `${baseUrl.Dashboard}/organizations/[slug]/operate/conversations`,
          Stores: `${baseUrl.Dashboard}/organizations/[slug]/operate/stores`,
          catalog: {
            Products: `${baseUrl.Dashboard}/organizations/[slug]/operate/catalog/products`,
            Stock: `${baseUrl.Dashboard}/organizations/[slug]/operate/catalog/stock`
          }
        },

        measure: {
          Insights: `${baseUrl.Dashboard}/organizations/[slug]/measure/insights`,
          Feedback: `${baseUrl.Dashboard}/organizations/[slug]/measure/feedback`,
          reports: {
            Index: `${baseUrl.Dashboard}/organizations/[slug]/measure/reports`,
            MissingInventory: `${baseUrl.Dashboard}/organizations/[slug]/measure/reports/missing-inventory`,
            OOS: `${baseUrl.Dashboard}/organizations/[slug]/measure/reports/oos`,
            Trends: `${baseUrl.Dashboard}/organizations/[slug]/measure/reports/trends`,
            Uplift: `${baseUrl.Dashboard}/organizations/[slug]/measure/reports/uplift`
          },
          Exports: `${baseUrl.Dashboard}/organizations/[slug]/measure/exports`
        }
      }
    },
    OrganizationsToKiosks: `${baseUrl.Dashboard}/organizations-to-kiosks`
  },
  marketing: {
    Api: `${baseUrl.Marketing}/api`,
    Blog: `${baseUrl.Marketing}/blog`,
    Careers: `${baseUrl.Marketing}/careers`,
    Contact: `${baseUrl.Marketing}/contact`,
    CookiePolicy: `${baseUrl.Marketing}/cookie-policy`,
    Docs: `${baseUrl.Marketing}/docs`,
    Index: `${baseUrl.Marketing}/`,
    Pricing: `${baseUrl.Marketing}/pricing`,
    PrivacyPolicy: `${baseUrl.Marketing}/privacy-policy`,
    Roadmap: 'https://retrend.canny.io',
    Story: `${baseUrl.Marketing}/story`,
    TermsOfUse: `${baseUrl.Marketing}/terms-of-use`
  }
} as const;

type ExtractSlugRoutes<T> =
  T extends Record<string, unknown>
    ? {
        [K in keyof T]: T[K] extends string
          ? T[K] extends `${string}[slug]${string}`
            ? T[K]
            : never
          : ExtractSlugRoutes<T[K]>;
      }[keyof T]
    : never;

type OrganizationsSlugRoutes = ExtractSlugRoutes<
  typeof routes.dashboard.organizations.slug
>;

export function replaceOrgSlug(
  route: OrganizationsSlugRoutes,
  slug: string
): string {
  if (route.indexOf('[slug]') === -1) {
    throw new Error(
      `Invalid route: ${route}. Route must contain the placeholder [slug].`
    );
  }

  return route.replace('[slug]', slug);
}

export function getPathname(route: string, baseUrl: string): string {
  return new URL(route, baseUrl).pathname;
}

export function getOrganizationLogoUrl(
  organizationId: string,
  hash: string
): string {
  return `${routes.dashboard.Api}/organization-logos/${organizationId}?v=${hash}`;
}

export function getUserImageUrl(userId: string, hash: string): string {
  return `${routes.dashboard.Api}/user-images/${userId}?v=${hash}`;
}

export function getContactImageUrl(contactId: string, hash: string): string {
  return `${routes.dashboard.Api}/contact-images/${contactId}?v=${hash}`;
}
